<template>
    <b-container v-show="showPlayer" class="divPlayerApp" fluid>
        <b-row align-h="center">
            <b-col cols="12" md="8" class="divPlayerApp2">
                <div class="d-flex justify-content-between">
                    <div>&nbsp;</div>
                    <div>
                        <b-button size="sm" @click.stop.prevent="rewind" class="mr-2"> <b-icon icon="arrow-counterclockwise"></b-icon> 15s</b-button>
                        <b-button size="sm" @click.stop.prevent="forward" class="ml-2">15s <b-icon icon="arrow-clockwise"></b-icon></b-button>
                    </div>
                    <div>
                        <b-button pill size="sm" @click.prevent="hidePlayer">&times;</b-button>
                    </div>
                </div>
                <vue-plyr ref="plyr">
                    <audio>
                        <!-- <source src="https://cdn.plyr.io/static/demo/Kishi_Bashi_-_It_All_Began_With_a_Burst.mp3" type="audio/mp3"/> -->
                    </audio>
                </vue-plyr>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"
import EventBus from '@/plugins/eventbus'

export default {
  name: "PodcastPlayer",
  data() {
    return {
        debug: false,
        player: null,
        showPlayer: false,
        mp3: null  // 'https://cdn.plyr.io/static/demo/Kishi_Bashi_-_It_All_Began_With_a_Burst.mp3'
    }
  },
  props: { },
  computed: { },
  // watch: {
  //   model: {
  //     deep: true,
  //     handler(modelArg) {  // receives updated this.model
  //       // console.log('searchBar watcher')
  //       // console.log(value)
  //       // Send updated model to parent.
  //       this.$emit('input', modelArg)  // send to listeners as input event
  //     }
  //   }
  // },
  methods: {
    rewind() {
        if (this.player.playing) {
            this.player.rewind(15)  // rewind 15 secs
        }
        else if (this.player.ended) {
            this.play(null)
        }
    },
    forward() {
        if (this.player.playing) {
            this.player.forward(15)  // forward 15 secs
        }
        else if (this.player.ended) {
            this.play(null)
        }
    },
    play(data) {
        if (!this.player) {
            this.playerEvents()
        }
        this.showPlayer = true
        if (data) {  // load new mp3   {mp3: '', title: ''}
          // console.log(`2) changing to: ${data.mp3}`)
          // source setter
          // https://github.com/sampotts/plyr#the-source-setter
          this.player.source = {
              type: 'audio',
              title: data.title,
              sources: [
                  {
                    src: data.mp3,
                    type: 'audio/mp3'
                  }
              ]
          }
          // console.log(this.player.source)
        }
        else {
          this.player.play()  // in case player x'ed out
        }
    },
    pause() {
        if (this.player) {
          // TBD emit event to pause
          this.player.pause()
        }
    },
    playerEvents () { // load player events
        if (this.$refs['plyr']) {
            // console.log(`playerEvents called`)

            this.player = this.$refs['plyr'].player

            // 'statechange','ready','canplay','error','progress','playing','play','pause','ended'
            this.player.on('statechange', () => console.log('event statechange'))
            this.player.on('ready', () => {
                if (this.debug) console.log('event ready')
            })
            this.player.on('canplay', (e) => {
                if (this.debug) console.log('event canplay')
                // console.log(e)
                this.player.play()
            })
            // this.player.on('canplaythrough', () => console.log('event canplaythrough'))
            this.player.on('error', () => console.log('event error'))
            // this.player.on('progress', () => console.log('event progress'))
            this.player.on('playing', () => {
                // emits on first play or after pause
                if (this.debug) console.log('event playing')
                EventBus.$emit('podcast-play-event')
            })
            this.player.on('play', () => {
                // sent on resume after pause only
                if (this.debug) console.log('event play')
            })
            this.player.on('pause', () => {
                if (this.debug) console.log('event pause')
                EventBus.$emit('podcast-pause-event')
            })
            this.player.on('ended', () => {
                if (this.debug) console.log('event ended')
            })
        }
        else {
            console.log(`plyr not found!`)
            // alert(`plyr not found`)
        }
    },
    hidePlayer() {  // when x is clicked
        // TBD emit event to reset podcast.vue settings
        // console.log(`hiding player`)
        this.pause()
        this.showPlayer = false
    },
    podcastPlay(data) {
        this.play(data)
    },
    podcastPause() {
        this.pause()
    }
  },
  created() {
      if (this.debug) console.log(`podcastPlayer created`)
      // setup events
      EventBus.$on('podcast-play', this.podcastPlay.bind(this))
      EventBus.$on('podcast-pause', this.podcastPause.bind(this))
   },
  mounted() {
      if (this.debug) console.log(`podcastPlayer mounted`)
  },
  beforeDestroy() {
      if (this.debug) console.log(`podcastPlayer destroyed`)
   }
}

</script>


// WEBPACK FOOTER //
// src/components/PodcastPlayer.vue